<template>
  <date-table
    :value="value"
    :selectedValue="selectedValue"
    @select="onDateTableSelect"
  />
</template>
<script>
// import { dayjs } from '@/utils/helpers';
// import { dayjs } from "@/utils/helpers";
import DateTable from "./DateTable.vue";
export default {
  name: "VCalendar",
  components: {
    DateTable
  },
  props: {
    value: Object,
    selectedValue: {
      type: [Object, Array],
      default: () => undefined
    },
    disabledDate: Function
  },
  provide() {
    return {
      calendar: this
    };
  },
  mounted() {
    this.$on("on-select", this.onDateTableSelect);
  },
  methods: {
    onDateTableSelect({ date, disalbed, selected }) {
      console.log(date);
      if (disalbed || selected) {
        return;
      }
      if (Array.isArray(this.selectedValue)) {
        this.$emit("update:selectedValue", [...this.selectedValue, date]);
        return;
      }

      this.$emit("update:selectedValue", date);

      if (!date.isSame(this.selectedValue)) {
        this.$emit("change", date);
      }
    },
    isDisabled(date) {
      if (this.disabledDate) {
        return this.disabledDate(date);
      }
      return false;
    }
  }
};
</script>
<style lang="">

</style>
